export namespace ENUM_PERSONAL_SITE {
  export const enum STATUS {
    /**
     * @param UN_INIT 未初始化
     * @description 若用户从未使用该功能，则返回该值 0
     */
    UN_INIT,
    /**
     * @param WAIT 等待审核
     */
    WAIT,
    /**
     * @param ACTIVATED 激活
     * @description 最新的自动审核流程需求功能
     */
    ACTIVATED,
    /**
     * @param 已停止使用
     */
    DEACTIVATED,
  }
}
